import { Avatar } from "../avatar";
import { resolveCompanyLogoUrl } from "../../constants/branding";

import { CompanyBrand, OpportunityName } from "./styled";

interface OpportunityIntroProps {
  avatarUrl: string;
  companyName: string;
  jobName: string;
}

export const CompanyIntro = ({ jobName, avatarUrl, companyName }: React.PropsWithChildren<OpportunityIntroProps>) => {
  return (
    <>
      <CompanyBrand>
        <div className="avatar">
          <Avatar url={resolveCompanyLogoUrl(avatarUrl)} />
          <p>{companyName}</p>
        </div>
      </CompanyBrand>

      {jobName && <OpportunityName>{jobName}</OpportunityName>}
    </>
  )
}
